import * as React from "react";
const SvgFiBrandsSlack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-slack_svg__a)">
      <path d="M5.264 15.158c0 1.395-1.179 2.526-2.632 2.526S0 16.553 0 15.158s1.178-2.526 2.631-2.526h2.632zM6.58 15.158c0-1.395 1.177-2.526 2.63-2.526 1.454 0 2.632 1.13 2.632 2.526v6.316c0 1.395-1.178 2.526-2.632 2.526-1.453 0-2.63-1.131-2.63-2.526zM9.21 5.053c-1.453 0-2.63-1.131-2.63-2.526C6.58 1.131 7.756 0 9.21 0c1.454 0 2.632 1.131 2.632 2.526v2.526zM9.21 6.316c1.454 0 2.632 1.13 2.632 2.526s-1.178 2.526-2.632 2.526H2.631C1.178 11.368 0 10.237 0 8.842s1.178-2.526 2.631-2.526zM19.737 8.842c0-1.395 1.178-2.526 2.63-2.526 1.455 0 2.633 1.13 2.633 2.526s-1.178 2.526-2.631 2.526h-2.631zM18.42 8.842c0 1.395-1.177 2.526-2.63 2.526s-2.632-1.131-2.632-2.526V2.526C13.158 1.131 14.337 0 15.79 0s2.63 1.131 2.63 2.526zM15.79 18.947c1.453 0 2.63 1.13 2.63 2.526s-1.177 2.526-2.63 2.526-2.632-1.131-2.632-2.526v-2.526zM15.79 17.684c-1.453 0-2.632-1.131-2.632-2.526s1.179-2.526 2.632-2.526h6.579c1.453 0 2.631 1.13 2.631 2.526s-1.178 2.526-2.631 2.526z" />
    </g>
    <defs>
      <clipPath id="fi-brands-slack_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsSlack;
